/**
 * Converts a 24-hour time string (e.g., "05:59") into the number of minutes since midnight.
 * Returns null if the format is invalid.
 *
 * @param {string} time24h - The time string in 24-hour format (HH:mm).
 * @returns {number|null} - The total minutes since midnight.
 */
export const parseTimeToMinutes = (time24h) => {
  if (!time24h) return null;
  const timeParts = time24h.split(':');
  if (timeParts.length !== 2) return null;
  const hour = parseInt(timeParts[0], 10);
  const minute = parseInt(timeParts[1], 10);
  if (isNaN(hour) || isNaN(minute)) return null;
  return hour * 60 + minute;
};

/**
 * Formats a total number of minutes (since midnight) into a 24-hour time string (HH:mm).
 *
 * @param {number} totalMinutes - The total minutes since midnight.
 * @returns {string} - The formatted time string in 24-hour format.
 */
export const formatMinutesToTime24h = (totalMinutes) => {
  const normalizedMinutes = ((totalMinutes % 1440) + 1440) % 1440;
  const hour = Math.floor(normalizedMinutes / 60);
  const minute = normalizedMinutes % 60;
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
};

/**
 * Formats countdown seconds to MM:SS format
 * @param {number} seconds - Total seconds
 * @returns {string} Formatted time string (e.g., "2:00")
 */
export const formatCountdown = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
};
